import React from 'react';
import Modal from 'simple-react-modal';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { SUMMER_PACK } from '../../constants/modals';
import SummerPackStore from '../../store/SummerPackStore';

import { dismissModal } from './services';


const SummerPackModal = (props) => {
  const { showSummerPackModal, closeSummerPackModal, user } = props;
  const { dismissModalInSession } = SummerPackStore;
  const handleDismissForever = () => {
    if (user.authenticated) {
      dismissModalInSession();
      dismissModal({
        visible: false,
        count: 1,
        modalType: SUMMER_PACK,
      });
    } else {
      const tenYears = moment().
        add(10, 'years').
        toDate();
      setCookie(tenYears);
    }
    closeSummerPackModal();
  };

  const handleClose = () => {
    dismissModalInSession();
    if (user.authenticated) {
      dismissModal({
        visible: true,
        count: 1,
        modalType: SUMMER_PACK,
      });
    } else {
      const nextWeek = moment().
        add(7, 'days').
        toDate();
      setCookie(nextWeek);
    }
    closeSummerPackModal();
  };

  const setCookie = (expiry) => {
    document.cookie = `SUMMER_PACK=hidden; expires=${expiry}`;
  };

  return (
    <Modal
      closeOnOuterClick={true}
      containerClassName="calendar-modal"
      show={showSummerPackModal}
      onClose={handleClose}
    >
      <div className={'calendar-modal-content summerpack-modal-content'}>
        <div className="calendar-modal-text-holder">
          <h2 className="summerpack-title">This Summer Promo Pack is on fire!</h2>
          <div className="summerpack-includes">Includes:</div>
          <ul className="summerpack-list">
            <li>Digital Magazine</li>
            <li>2021 Calendar</li>
            <li>Exclusive Tie Challenge</li>
          </ul>
          <div className="summerpack-highlight">Don't miss out, get yours today!</div>
          <div className="summerpack-small-text">Limited time offer</div>
        </div>
      </div>
      <div className="calendar-modal-footer">
        <Link
          className="btn btn-red"
          to="/summerpack-purchase"
          onClick={closeSummerPackModal}
        >
          I want it!
        </Link>
        <div className="calendar-modal-dismiss" onClick={handleDismissForever}>
          I don't want to see this message again
        </div>
      </div>
      <span className="calendar-modal-close-btn" onClick={handleClose}>X</span>
    </Modal>
  );
};

export default SummerPackModal;
